import cx from 'classnames';
import { isAnonymousUser } from 'mk/bazaar/common/userUtils';
import assetUrl from 'mk/common/assetUrl';
import { blogsProfileUrl } from 'mk2/apps/blogs/urls';
import { ANONYMOUS_POST_HELP_LINK } from 'mk2/apps/forum/constants';
import { fixUsername } from 'mk2/apps/users/utils';
import AvatarImg from 'mk2/components/AvatarImg';
import Img from 'mk2/components/Img';
import Link from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import { UserDomainDataEntity, UserEntity } from 'mk2/schemas';
import React from 'react';
import styles from './FeedItemLikedProfile.mscss';

interface OwnProps {
    user: UserEntity;
    userDomainData: UserDomainDataEntity;
    className?: string;
}

export class FeedItemLikedProfile extends React.PureComponent<OwnProps> {

    public render() {
        const { user, userDomainData, className} = this.props;

        const isAnonUser = isAnonymousUser(user);
        const profileUrl: string = url(blogsProfileUrl, { username: user.username });

        return (
            <div className={cx(styles.FeedItemLikedProfile, className)}>
                {isAnonUser ? (
                    <Img
                        className={styles.FeedItemLikedProfile__avatar}
                        src={`${assetUrl}img/avatars/user/zorro-avatar.png`}
                        width={50}
                        height={50}
                    />
                ) : (
                    <AvatarImg
                        className={styles.FeedItemLikedProfile__avatar}
                        size={50}
                        user={user}
                    />
                )}

                <div className={styles.FeedItemLikedProfile__details}>
                    <Link
                        className={styles.FeedItemLikedProfile__details__username}
                        to={isAnonUser ? ANONYMOUS_POST_HELP_LINK : profileUrl}
                    >
                        {fixUsername(user.username)}
                    </Link>
                    <div>
                        {userDomainData.domainText}
                    </div>
                    <div>
                        {userDomainData.userText}
                    </div>
                </div>
            </div>
        );
    }
}
